import { LabelManagementProvider } from '@aibees/elephant/components/search-table-action-dialog-lists/context';
import { RecordManagementLabels } from '@aibees/elephant/feature/search-drawer/components/record-management-labels';
import { LabelType } from '@aibees/elephant/types/label';
import { classnames } from '@aibees/shared/utils';
import { Box, Divider, Typography } from '@mui/material';
import { memo } from 'react';
import { EnrichmentReportCard } from '../enrichment-report-card';
import { FileInfo } from '../file-info';
import { InfoItem } from '../info-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichmentFileManagementProps as Props } from './types';

export const EnrichmentFileManagement = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('FileManagement', className)}
      sx={SX.root}
    >
      <EnrichmentReportCard title="File Managements">
        <Box sx={SX.content}>
          <FileInfo />
          <Divider sx={SX.divider} />
          <Box sx={SX.list}>
            <LabelManagementProvider onChangeLabels={() => {}}>
              <RecordManagementLabels
                labelType={LabelType.LIST}
                iconAddButton="account-list"
              />
            </LabelManagementProvider>
          </Box>
          <Divider sx={SX.divider} />
          <Box sx={SX.list}>
            <LabelManagementProvider onChangeLabels={() => {}}>
              <RecordManagementLabels
                labelType={LabelType.LABEL}
                iconAddButton="tags"
              />
            </LabelManagementProvider>
          </Box>
          <Divider sx={SX.divider} />

          <InfoItem
            icon="calender-view-day"
            title="Total Rows"
            value={<Typography sx={SX.text1}>1,000</Typography>}
          />
          <Divider sx={SX.divider} />

          <InfoItem
            icon="coin"
            title="Credit Cost"
            value={<Typography sx={SX.text1}>-5,285</Typography>}
          />
          <Divider sx={SX.divider} />

          <InfoItem
            icon="clock"
            title="Upload Date"
            value={<Typography sx={SX.text2}>June 26, 2023 - 07:17</Typography>}
          />
        </Box>
      </EnrichmentReportCard>
    </Styled.Wrapper>
  );
});

EnrichmentFileManagement.displayName = 'EnrichmentFileManagement';
